import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const InformationFlow = Loadable({
    loader: () => import(/* webpackChunkName: "InformationFlow" */ './informationFlow'),
    loading: () => <div />,
});
export const SingleTitle = Loadable({
    loader: () => import(/* webpackChunkName: "SingleTitle" */ './informationFlow/components/singleTitle'),
    loading: () => <div />,
});
export const TitleImg = Loadable({
    loader: () => import(/* webpackChunkName: "TitleImg" */ './informationFlow/components/titleImg'),
    loading: () => <div />,
});
export const BigImg = Loadable({
    loader: () => import(/* webpackChunkName: "BigImg" */ './informationFlow/components/bigImg'),
    loading: () => <div />,
});
export const BigTopic = Loadable({
    loader: () => import(/* webpackChunkName: "BigTopic" */ './informationFlow/components/bigTopic'),
    loading: () => <div />,
});
export const SlideImg = Loadable({
    loader: () => import(/* webpackChunkName: "SlideImg" */ './informationFlow/components/slideImg'),
    loading: () => <div />,
});
export const TwoImg = Loadable({
    loader: () => import(/* webpackChunkName: "TwoImg" */ './informationFlow/components/twoImg'),
    loading: () => <div />,
});
